import { fetchError, fetchRequest, fetchSuccess} from "./actions";
import { fetch} from "../../repo/closeloop";
import { isEmpty} from "ramda";
import { isAuthError} from "../index";
import { put, takeEvery} from "redux-saga/effects";
import { dirty } from "../session/actions";
import { CloseLoopActionTypes } from "./types";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const closeloop = yield fetch(action.payload.id, action.payload.params);
    if (closeloop.errors && !isEmpty(closeloop.errors)) {
      if (isAuthError(closeloop.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(closeloop.errors)));
    } else {
      yield put(fetchSuccess(closeloop));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(CloseLoopActionTypes.FETCH, handleFetch);
}

export default watchFetchRequest;
